export const huns = [
    {id:1,   name:"Mercenary", wood:130, clay:80, iron:40, crop:40},
    {id:2,   name:"Bowman", wood:140, clay:110, iron:60, crop:60},
    {id:3,   name:"Spotter", wood:170, clay:150, iron:20, crop:40},
    {id:4,   name:"Steppe Rider", wood:290, clay:370, iron:190, crop:45},
    {id:5,   name:"Marksman", wood:320, clay:350, iron:330, crop:50},
    {id:6,   name:"Marauder", wood:450, clay:560, iron:610, crop:140	},
    {id:7,   name:"Ram", wood:1060, clay:330, iron:360, crop:70},
    {id:8,   name:"Catapult", wood:950, clay:1280, iron:620, crop:60},
    {id:9,   name:"Logades", wood:37200, clay:27600, iron:25200, crop:27600},
    {id:10,  name:"Settler", wood:6100, clay:4600, iron:4800, crop:5400}
]